<template>
  <v-form>
    <v-container>
      <div style="height: 10px;"></div>

      <div style="font-size: 20px;">{{ selectedStore.storeName }}</div>

      <div style="height: 30px;"></div>

      <v-text-field
        v-model="stocktakingMonth"
        :label="$t('sales.stocktaking-month')"
        prepend-icon="event"
        box
        readonly
      ></v-text-field>

      <v-autocomplete
        v-model="selectedUsers"
        :items="sales"
        item-value="userId"
        item-text="userName"
        :label="$t('sales.salesperson')"
        persistent-hint
        prepend-icon="group"
        multiple
        chips
        deletable-chips
        @change="changeSelectedUser()"
      ></v-autocomplete>
      <div style="height: 30px;"></div>

      <v-card>
        <v-container>
          <v-card-title>{{ $t('sales.stocktaking') }}</v-card-title>

          <div style="height: 30px;"></div>

          <v-layout row wrap align-center>
            <v-flex xs12>
              <v-text-field
                type="Number"
                min="0"
                v-model="search"
                append-icon="search"
                :label="$t('sales.stocktaking-search')"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>

            <div style="height: 35px;"></div>

            <v-data-table
              id="dt"
              :headers="headers"
              :items="itemsInStore"
              hide-actions
              class="elevation-1"
              style="width: 100%; margin: 15px 0 0;"
              :search="search"
              :customFilter="customFilter"
              :no-data-text="$t('noTableDataAvailable')"
            >
              <tr></tr>

              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-center px-2">{{ props.item.janCode }}</td>
                  <td class="text-xs-left px-2">{{ props.item.itemName }}</td>
                  <td class="text-xs-right px-2">{{ props.item.stockQuantity }}</td>
                </tr>
              </template>
            </v-data-table>

            <v-flex xs12 sm12>
              <div style="height: 30px;"></div>
            </v-flex>

            <v-flex xs12 sm12 v-for="item in dispRemarksList" :key="item.userName">
              <v-textarea outline :label="item.userName + 'さんの追伸'" readonly :value="item.remarks"></v-textarea>
            </v-flex>

            <v-flex xs12 sm12>
              <v-checkbox
                v-model="expirationDateFlg"
                :label="$t('sales.stock-expired')"
                color="red"
              ></v-checkbox>
              <v-checkbox v-model="oldDesignFlg" :label="$t('sales.old-designs')" color="red"></v-checkbox>
            </v-flex>

            <v-flex xs12 sm12>
              <v-alert
                :value="true"
                color="error"
                icon="info"
                outline
                class="font-weight-bold"
                style="text-align: left;"
              >{{ $t('sales.check-salesperson') }}</v-alert>
            </v-flex>

            <v-flex xs12 sm12>
              <v-btn
                large
                block
                color="warning"
                dark
                @click="stocktakingConfirm()"
                :loading="loading"
              >{{ $t('sales.stocktaking-finish-btn') }}</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>

      <div style="height: 35px;"></div>

      <div style="height: 35px;"></div>

      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-btn block color="#4C728A" dark :to="{ name: 'sales/Stocktaking' }">
            <v-icon dark left>arrow_back</v-icon>
            {{ $t('back-btn') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import moment from 'moment-timezone'

export default {
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)

    this.stocktakingMonth = this.$route.params.stocktakingMonth

    this.getStocktakingConfirmItems()
  },
  computed: {
    ...mapState({
      user: state => state.user,
      selectedStore: state => state.salesSession.menuSelectedStore
    })
  },
  methods: {
    customFilter(items, search) {
      console.log('custom filter')

      if (!search) {
        return items
      } else {
        let filteringItems = items.filter(function(value) {
          if (value.janCode.includes(search)) {
            return true
          } else {
            return false
          }
        })
        return filteringItems
      }
    },
    getStocktakingConfirmItems() {
      let thisObj = this

      let request = {
        stocktakingMonth: this.stocktakingMonth.replace(/\//g, ''),
        storeCode: this.selectedStore.storeCode
      }

      ServerApiCallService.stocktakingConfirmItems(request)
        .then(response => {
          this.stocktakingConfirmItems = response.data.itemsByUserId

          this.itemsInStore = response.data.items

          this.remarksList = response.data.remarksList

          // 表示用備考欄
          this.dispRemarksList = response.data.remarksList

          var userInfoList = response.data.itemsByUserId

          for (var i in userInfoList) {
            var userInfo = []
            userInfo.userName = userInfoList[i].userName
            userInfo.userId = userInfoList[i].createdUser
            this.sales.push(userInfo)
          }

          // 重複ユーザー情報の削除
          this.sales = this.sales.filter(
            (item, index, self) =>
              self.findIndex(t => {
                return item.userId === t.userId
              }) === index
          )

          // 保存されているユーザーデータがある場合、取り込む処理
          if (response.data.itemsByUserId) {
            thisObj.itemsInStore.forEach(function(row) {
              row.quantity = 0
              response.data.itemsByUserId.forEach(function(userData) {
                if (row.itemCode == userData.itemCode) {
                  row.quantity += userData.stockQuantity
                }
              })
              row.stockQuantity = row.quantity
            })
          }

          // 商品の表示順 商品カテゴリ、商品名
          thisObj.itemsInStore.sort(function(a, b) {
            if (a.itemName > b.itemName) return 1
            if (a.itemName < b.itemName) return -1
            // a must be equal to b
            return 0
          })
          thisObj.itemsInStore.sort(function(a, b) {
            if (a.itemCategoryId > b.itemCategoryId) return 1
            if (a.itemCategoryId < b.itemCategoryId) return -1
            // a must be equal to b
            return 0
          })
          // janCodeの変換
          thisObj.itemsInStore.forEach(function(row) {
            row.janCode = row.janCode.substr(9, 4)
          })

          // 「販売員」の初期表示
          this.sales.forEach(function(row) {
            thisObj.selectedUsers.push(row.userId)
          })
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    },
    changeSelectedUser() {
      console.log('change selectedUser')
      var thisObj = this

      var itemsInStoreTmp = this.itemsInStore

      this.itemsInStore = []

      itemsInStoreTmp.forEach(function(row) {
        row.quantity = 0
        thisObj.stocktakingConfirmItems.forEach(function(userData) {
          if (
            row.itemCode == userData.itemCode &&
            thisObj.selectedUsers.includes(userData.createdUser)
          ) {
            row.quantity += userData.stockQuantity
          }
        })
        row.stockQuantity = row.quantity
        thisObj.itemsInStore.push(row)
      })

      // 備考の表示
      this.dispRemarksList = []

      this.remarksList.forEach(function(row) {
        if (thisObj.selectedUsers.includes(row.userId)) {
          thisObj.dispRemarksList.push(row)
        }
      })
      console.log('selected users: ' + this.selectedUsers)
    },
    stocktakingConfirm() {
      console.log('stocktaking confirm')
      this.loading = true

      let request = {
        storeCode: this.selectedStore.storeCode,
        stocktakingConfirmItems: this.itemsInStore,
        stocktakingMonth: this.stocktakingMonth.replace(/\//g, ''),
        selectedUsers: this.selectedUsers,
        expirationDateFlg: this.expirationDateFlg === true ? '1' : '0',
        oldDesignFlg: this.oldDesignFlg === true ? '1' : '0'
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent,
        forwardNameOnClose: 'sales/Stocktaking',
        dialogMessage: this.$t('sales.stocktaking-finish-message')
      }

      ServerApiCallService.confirmStocktaking(request, sendContext)
        .then(response => {
          this.$router.push({
            name: 'sales/Stocktaking'
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
          this.loading = false
        })
    }
  },
  data() {
    return {
      expirationDateFlg: '',
      oldDesignFlg: '',
      remarks: '',
      sales: [],
      itemsInStore: [],
      selectedUsers: [],
      loading: false,
      stocktakingMonth: '',
      search: '',
      stocktakingConfirmItems: [],
      headers: [
        {
          text: 'No',
          align: 'left',
          value: 'itemCode',
          width: '5%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('sales.product-name'),
          align: 'left',
          value: 'itemName',
          width: '85%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: '物理在庫数',
          align: 'right',
          sortable: false,
          value: 'stockQuantity',
          width: '10%',
          fixed: true,
          class: 'px-2'
        }
      ],
      dispRemarksList: [],
      remarksList: []
    }
  }
}
</script>

<style>
#dt tr:nth-child(even) {
  background-color: #f2f2f2;
}
.class-on-data-table table {
  table-layout: fixed;
}
</style>
